import {
  SHOW_MOB_MENU,
  HIDE_MOB_MENU,
  TOGGLE_MODAL,
  SUBMISSION_DEADLINE_EXPIRED,
  RESET_STORE_PROPS,
  GET_LOGIN_DATA,
  GET_INFO,
  SAVE_SESSION_AND_INFO,
  SET_PAGE_WIDTH,
  GALLERY_FULLSCREEN_TOGGLE,
  SET_LANGUAGE,
} from "../actions/types";
import ACTIONS from "../actions/types";

const initialState = {
  lang: "de-DE",
  mobMenuDisplay: false,
  isMainMenuVisible: true,
  isMainMenuVisibleOnTop: false,
  isHelperMenuPresent: false,
  isHelperMenuVisibleOnTop: false,
  modalBackVisibility: false,
  loaderVisiblity: false,
  gallery: {
    fullScreen: false,
  },
  rerenderModal: null,
  //helperSideNavToggle: true, // remove this when helper nav is done
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        lang: action.payload,
      };
    case ACTIONS.SET_SCREEN_SIZE:
      return {
        ...state,
        sizeOfTheScreen: action.payload,
      };
    case SAVE_SESSION_AND_INFO:
      return {
        ...state,
        info: action.info,
      };
    case "SET_INFO":
      return {
        ...state,
        info: action.info,
      };
    case GET_INFO:
      return {
        ...state,
        info: action.payload,
        EndsAt: action.payload.apps[action.payload.default_app].modules.submitter.end_at,
        counterActive: action.payload.apps[action.payload.default_app].modules.submitter.active,
      };
    case "SAVE_INFO":
      return {
        ...state,
        info: action.payload,
        EndsAt: action.payload.apps[action.payload.default_app].modules.submitter.end_at,
        counterActive: action.payload.apps[action.payload.default_app].modules.submitter.active,
      };
    case GET_LOGIN_DATA:
      return {
        ...state,
        loginData: action.payload,
      };
    case SUBMISSION_DEADLINE_EXPIRED:
      return {
        ...state,
        counterActive: false,
      };
    case SHOW_MOB_MENU:
      return {
        ...state,
        mobMenuDisplay: true,
        modalBackVisibility: true,
      };
    case HIDE_MOB_MENU:
      return {
        ...state,
        mobMenuDisplay: false,
        modalBackVisibility: false,
      };
    case SET_PAGE_WIDTH:
      return {
        ...state,
        screenSize: action.payload,
      };
    case TOGGLE_MODAL:
      return {
        ...state,
        modalBackVisibility: !state.modalVisiblity ? true : false,
        modalVisiblity: !state.modalVisiblity,
        mobMenuDisplay: false,
      };
    case ACTIONS.TOGGLE_HELLPER_SIDE_NAV:
      return {
        ...state,
        helperSideNavToggle: !state.helperSideNavToggle,
      };
    case ACTIONS.SHOW_HELLPER_SIDE_NAV:
      return {
        ...state,
        helperSideNavToggle: true,
      };
    case ACTIONS.HIDE_HELLPER_SIDE_NAV:
      return {
        ...state,
        helperSideNavToggle: false,
      };
    case "PUT_HELLPER_SIDE_NAV_ON_TOP":
      return {
        ...state,
        helperSideNavOnTop: true,
      };
    case RESET_STORE_PROPS:
      return {
        ...state,
        mobMenuDisplay: false,
        modalBackVisibility: false,
        colorAlert: false,
        loaderVisiblity: false,
      };
    case "TOGGLE_MODAL_BACKGROUND":
      return {
        ...state,
        modalBackVisibility: action.payload,
      };
    case GALLERY_FULLSCREEN_TOGGLE:
      return {
        ...state,
        gallery: {
          fullScreen: !state.gallery.fullScreen,
        },
      };
    case "SET_APP_TITLE":
      return {
        ...state,
        appTitle: action.payload,
      };
    case "HIDE_APP_TITLE":
      return {
        ...state,
        appTitle: null,
      };
    case "SET_COUNTER":
      return {
        ...state,
        counterEndsAt: action.payload,
      };
    case "RERENDER_MODAL":
      return {
        ...state,
        rerenderModal: action.payload,
      };

    case ACTIONS.ERROR_POPUP:
      return {
        ...state,
        errorPopup: true,
      };
    case ACTIONS.DISPLAY_IMAGE:
      return {
        ...state,
        galleryItemID: action.payload,
      };

    // new template
    case ACTIONS.HIDE_MAIN_MENU:
      return {
        ...state,
        isMainMenuVisible: false,
      };
    case ACTIONS.SHOW_MAIN_MENU:
      return {
        ...state,
        isMainMenuVisible: true,
      };
    case ACTIONS.SHOW_MAIN_MENU_ON_TOP:
      return {
        ...state,
        isMainMenuVisibleOnTop: true,
      };
    case ACTIONS.HIDE_MAIN_MENU_ON_TOP:
      return {
        ...state,
        isMainMenuVisibleOnTop: false,
      };
    case ACTIONS.SET_HELPER_NAV_AS_PRESENT:
      return {
        ...state,
        isHelperMenuPresent: true,
      };
    case ACTIONS.SET_HELPER_NAV_AS_NOT_PRESENT:
      return {
        ...state,
        isHelperMenuPresent: false,
      };
    case ACTIONS.SHOW_HELPER_NAV_ON_TOP:
      return {
        ...state,
        isHelperMenuVisibleOnTop: true,
      };
    case ACTIONS.HIDE_HELPER_NAV_ON_TOP:
      return {
        ...state,
        isHelperMenuVisibleOnTop: false,
      };
    case ACTIONS.SHOW_COOKIE_PROMPTER:
      return {
        ...state,
        isCookiePrompterVisible: true,
      };
    case ACTIONS.HIDE_COOKIE_PROMPTER:
      return {
        ...state,
        isCookiePrompterVisible: false,
      };

    case ACTIONS.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default appReducer;
